<!-- Navigation -->
<template>
  <div id="navigation" class="navigation">
    <div class="wrap navigation-wrap">
      <!-- logo -->
      <div class="navigation-left">
        <div class="navigation-logo"></div>
        <div
          class="navigation-selected-bg"
          :style="{
            transform: `translateX(${navIndex * 1.4 + 1.46}rem) skewX(-15deg)`,
            opacity: navIndex == -1 ? 0 : 1,
          }"
        ></div>
        <!-- DSP导航 -->
        <Dropdown v-for="(item, index) in navList" :key="index" trigger="click">
          <div
            @click="changeNav(item)"
            class="navigation-item"
            :class="{ 'navigation-selected': navIndex == index }"
          >
            <i class="icon" :class="'navigation-icon' + item.key"></i>
            <span class="navigation-name">{{ item.name }}</span>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="child in item.children"
              :key="child.key"
              :name="child.key"
            >
              <p @click="changeChildrenNav(child.link)">{{ child.name }}</p>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="navigation-right">
        <!-- 时区切换 -->
        <Dropdown trigger="click" @on-click="timeZoneChange">
          <div>
            {{ timeZoneValue }}
            <Icon type="arrow-down-b"></Icon>
          </div>
          <Dropdown-menu slot="list">
            <DropdownItem
              v-for="(item, index) in timeZone"
              :key="item.name + index"
              :name="item.name"
              >{{ item.label }}</DropdownItem
            >
          </Dropdown-menu>
        </Dropdown>

        <!-- 账号切换 -->
        <Dropdown trigger="click" @on-click="accountChange">
          <div class="change-item">
            <span class="change-name">{{ account }}</span>
            <Icon type="arrow-down-b"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(item, index) in accountList"
              :key="index"
              :name="item.value"
              >{{ item.label }}</DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
        <!-- 平台切换 -->
        <Dropdown trigger="click" @on-click="platformChange">
          <div class="change-item">
            <span class="change-name">切换</span>
            <Icon type="arrow-down-b"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="item in platformList"
              :key="item.link"
              :name="item.link"
              >{{ item.name }}</DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import routes from "@/router/routes.js";
export default {
  name: "TheNavigation",
  data() {
    return {
      //当前导航高亮
      navList: [],
      accountList: [
        {
          value: "true",
          label: "退出",
        },
      ],
      //平台列表
      platformList: [
        {
          value: false,
          name: "AdFun Dsp",
          link: this.$port.dspIndex,
        },
      ],
      account: "",
      timeZone: [
        { name: "0", label: "GMT+00:00" },
        { name: "1", label: "GMT+08:00" },
      ],
      timeZoneValue: "",
    };
  },
  computed: {
    // 可展示的导航列表
    canShowNavList() {
      return this.navList;
    },
    navIndex() {
      // let index = -1;
      // if (this.$route.meta.key) index = ~~this.$route.meta.key[0] - 1;
      // return index;
      if (this.canShowNavList && this.canShowNavList.length) {
        return this.canShowNavList.findIndex(
          (item) => item.key == this.$route.meta.key[0]
        );
      }
      return -1;
    },
  },
  mounted() {
    this.timeZoneValue_Fun(this.getCookie("adfun_timezone") || 1);
    this.getUserData();
    // map导航列表
    this.navList = routes
      .filter((item) => item.meta && item.meta.key.length == 1)
      .map((item) => ({
        name: item.meta.menu,
        link: item.path,
        key: item.meta.key,
        children: (() => {
          if (item.children) {
            return item.children
              .filter((item) => item.meta)
              .map((child) => ({
                name: child.meta.menu,
                link: item.path + "/" + child.path,
                key: child.meta.key,
              }));
          }
          return [];
        })(),
      }));
  },
  methods: {
    /*
     * @desc 设置时区逻辑
     *
     */
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    timeZoneValue_Fun(status) {
      this.timeZoneValue = this.timeZone.find(
        (item) => item.name == status
      ).label;
    },
    timeZoneChange(status) {
      console.log(".....", status);
      this.timeZoneValue_Fun(status);

      document.cookie =
        "adfun_timezone=" + status + ";path=/;domain=adfundsp.com";
      location.reload();
    },
    //*********************************************************** */

    /*
     * @desc 切换导航
     * @params item:obj 导航选项item
     */
    changeNav(item) {
      if (item.children.length) return;
      this.$router.push(item.link);
    },
    /*
     * @desc 切换子导航
     * @param link:string 导航的路由url
     */
    changeChildrenNav(link) {
      this.$router.push(link);
    },
    /*
     * @description 切换平台
     * @params url:string 平台的url
     */
    platformChange(url) {
      console.log("跳转", url);
      window.location.href = url;
    },
    /*
     * @description 切换账号,退出登录
     */
    async accountChange() {
      const res = await this.$axios.get(this.$port.manager.logout);
      window.location.href = this.$port.dspLogin;
    },
    /*
     * @description 获取用户信息
     */
    async getUserData() {
      const res = await this.$axios.get(this.$port.manager.getUserData);
      if (res.data.accountType != 3) {
        window.location.href = this.$port.dspIndex;
      }
      this.account = res.data.email;
      this.$store.commit("setUserData", res.data);
    },
  },
};
</script>
<style lang="scss">
@import "src/style/frequently";
#navigation {
  width: 100%;
  height: 0.7rem;
  background-color: $impColor;
  .navigation-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $impColor;
    .ivu-select-dropdown {
      padding: 0;
      .ivu-dropdown-menu {
        text-align: center;
        .ivu-dropdown-item {
          line-height: 0.4rem;
          color: #999999;
        }
        .ivu-dropdown-item-selected,
        .ivu-dropdown-item-selected:hover {
          color: white;
        }
      }
    }
    .navigation-left {
      display: flex;
      flex: 1 1 auto;
      position: relative;
      .ivu-dropdown-item {
        padding: 0;
      }
      .navigation-logo {
        width: 1.46rem;
        height: 0.65rem;
        background-image: url("../assets/logo.png");
        background-position: 0 center;
        cursor: inherit;
      }
      .navigation-item {
        display: flex;
        align-items: center;
        height: 0.7rem;
        padding: 0 0.2rem;
        line-height: 0.75rem;
        font-size: 0.15rem;
        color: #fff;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease;
        .icon {
          height: 0.2rem;
          width: 0.28rem;
        }
        .navigation-icon1 {
          background-position: -0.1rem -0.28rem;
        }
        .navigation-icon2 {
          background-position: -0.8rem -0.275rem;
        }
        .navigation-icon3 {
          background-position: -1.51rem -0.29rem;
        }
        .navigation-icon4 {
          background-position: -2.2rem -0.29rem;
        }
        .navigation-icon5 {
          background-position: -2.91rem -0.285rem;
        }
        .navigation-icon6 {
          background-position: -3.6rem -0.275rem;
        }
        &:hover {
          color: #1a750b;
          .navigation-icon1 {
            background-position: -0.1rem -0.78rem;
          }
          .navigation-icon2 {
            background-position: -0.8rem -0.775rem;
          }
          .navigation-icon3 {
            background-position: -1.51rem -0.79rem;
          }
          .navigation-icon4 {
            background-position: -2.2rem -0.79rem;
          }
          .navigation-icon5 {
            background-position: -2.91rem -0.785rem;
          }
          .navigation-icon6 {
            background-position: -3.6rem -0.775rem;
          }
        }
      }
      //选中状态
      .navigation-selected-bg {
        position: absolute;
        top: 0;
        height: 0.7rem;
        width: 1.4rem;
        background: #2c9f1a;
        transition: all 0.5s ease;
      }
      .navigation-selected {
        &:hover {
          color: #fff;
          .navigation-icon1 {
            background-position: -0.1rem -0.28rem;
          }
          .navigation-icon2 {
            background-position: -0.8rem -0.275rem;
          }
          .navigation-icon3 {
            background-position: -1.51rem -0.29rem;
          }
          .navigation-icon4 {
            background-position: -2.2rem -0.29rem;
          }
          .navigation-icon5 {
            background-position: -2.91rem -0.285rem;
          }
          .navigation-icon6 {
            background-position: -3.6rem -0.275rem;
          }
        }
      }
    }
    .navigation-right {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.14rem;
      color: #fff;
      .change-item {
        height: 0.7rem;
        line-height: 0.7rem;
        position: relative;
        padding: 0 0.16rem 0 0.2rem;
        text-align: right;
        transition: color 0.2s ease;
        &:hover {
          color: $impColor * 0.5;
        }
        .change-name {
          margin-right: 0.04rem;
        }
      }
    }
  }
}

.navigation-name {
  min-width: 0.75rem;
  position: relative;
  width: fit-content;
}
.navigation-left > div:last-child {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TheNavigation.vue